module.exports = __webpack_public_path__ + "static/media/qty-minus-brand-refresh.2d21d2a4.svg";